export const actionTypes = {
  INITIALIZE_PRODUCTS: "INITIALIZE_PRODUCTS",
  UPDATE_PRODUCTS: "UPDATE_PRODUCTS",

  INITIALIZE_CART: "INITIALIZE_CART",
  ADD_PRODUCT_TO_CART: "ADD_PRODUCT_TO_CART",
  UPDATE_PRODUCT_QTY_IN_CART: "UPDATE_PRODUCT_QTY_IN_CART",
  DELETE_PRODUCTS_FROM_CART: "DELETE_PRODUCTS_FROM_CART",

  INITIALIZE_WISHLIST: "INITIALIZE_WISHLIST",
  ADD_PRODUCT_TO_WISHLIST: "ADD_PRODUCT_TO_WISHLIST",
  DELETE_PRODUCTS_FROM_WISHLIST: "DELETE_PRODUCTS_FROM_WISHLIST",

  INITIALIZE_CATEGORIES: "INITIALIZE_CATEGORIES",
};
export const filterTypes = {
  INITIALIZE_FILTERS: "INITIALIZE_FILTERS",
  FILTERS: "FILTERS",
  CLEAR_FILTER: "CLEAR_FILTER",
};

export const addressTypes = {
  ADD_ADDRESS: "ADD_ADDRESS",
  UPDATE_ADDRESS: "UPDATE_ADDRESS",
  DELETE_ADDRESS: "DELETE_ADDRESS",
};
